import React from "react";
import NavPort from "./Navv";
 
const GraphicsPortfolio=()=>{
    return(

<section id="clients" class="section-bg">

<div class="container">
<NavPort/>
  <div class="section-header">
    <h3>Our CLients</h3>
    <p>From your website, to your business card, to your print materials, your brand identity should come through loud and clear. Webolutions can help you create or adapt your brand identify then make sure that all your materials are a visual reflection of the brand. Every experience, through every point of contact with your business, should convey the same, clearly defined, core brand themes and vocabulary.</p>
  </div>

  <div class="row no-gutters clients-wrap clearfix wow fadeInUp" >

    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460149/abof.png" class="img-fluid" alt=""/>
      </div>
    </div>
    
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460224/cropped-cropped-20170720-lucuLogo-squ2-e1500543540803.png" class="img-fluid" alt=""/>
      </div>
    </div>
  
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460269/104840a62d46c05d285762857fecb61a.png" class="img-fluid" alt=""/>
      </div>
    </div>
    
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460358/client-4.png" class="img-fluid" alt=""/>
      </div>
    </div>
    
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460379/client-5.png" class="img-fluid" alt=""/>
      </div>
    </div>
  
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460398/client-6.png" class="img-fluid" alt=""/>
      </div>
    </div>
    
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://res.cloudinary.com/dxfq3iotg/image/upload/v1559460418/client-7.png" class="img-fluid" alt=""/>
      </div>
    </div>
    
    <div class="col-lg-3 col-md-4 col-xs-6">
      <div class="client-logo">
        <img src="https://bootstrapmade.com/demo/themes/NewBiz/img/clients/client-8.png" class="img-fluid" alt=""/>
      </div>
    </div>

  </div>

</div>

</section>


    );
}

export default GraphicsPortfolio;
